module.exports = "<p>doceree-ad works!</p>\n1st Ad\n<div id='DOC_fg95yysk21ib1qg'></div>\n\n<p>2nd Ad</p>\n<div id='DOC_fg95yysk21n1dl7'></div>"